module.exports = __webpack_public_path__ + "static/img/server-thumb.ff64477.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/features/server-thumb.png
// module id = q/5F
// module chunks = 6